import parseToken from "../../../helpers/parseToken"
import {createContext, useEffect, useState} from "react"
import {getApParam2, getTenants} from "../../../services/api/apiCommon"
import {message} from "antd"
import {getSettingTenantParam} from "../../../services/api/apiSetting"
import queryString from 'query-string'

export const Context = createContext({})

export const Provider = (props) => {
    const info = parseToken()
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [filters, setFilters] = useState({
        tenantId: '',
        paramName: ''
    })

    const [pagination, setPagination] = useState({
        page: 1,
        size: 50
    })

    const [listTenant, setListTenant] = useState([])
    const [listParam, setListParam] = useState([])
    const [listTenantParam, setListTenantParam] = useState()
    const [total, setTotal] = useState(0)

    const _onChangeFilter = (name, value) => {
        setFilters({
            ...filters,
            [name]: value
        })
    }

    const _fetchListSettingTenant = async () => {
        setLoading(true)
        setError('')

        try {
            const query = {
                ...filters,
                ...pagination
            }

            const newQueryString = queryString.stringify(query)

            const response = await getSettingTenantParam(newQueryString, info.sub)

            const {success, data, error_message, totalRecord} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setLoading(false)
            setError('')
            setListTenantParam(data)
            setTotal(totalRecord)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchListTenant = async () => {
        try {
            const response = await getTenants({}, info.sub)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            setListTenant([...data])
        } catch (e) {
            message.error(e.message)
        }
    }

    const _fetchListFilter = async () => {
        try {
            const payload = {
                "parType": ["DEFAULT"],
                "parCode": ["TENANT_PARAM_NAME"]
            }
            const response = await getApParam2(payload)

            const {success, data, error_message} = response

            if (parseInt(success) !== 1) {
                return message.error(error_message)
            }

            const _listParam = data.filter(item => item.parCode === 'TENANT_PARAM_NAME').map(item => {
                return {
                    name: item.parName,
                    id: item.parName
                }
            })

            setListParam(_listParam)

        } catch (e) {
            message.error(e.message)
        }
    }

    useEffect(() => {
        _fetchListTenant()
        _fetchListFilter()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        _fetchListSettingTenant()

        return () => {
            setLoading(false)
            setError('')
        }
        // eslint-disable-next-line
    }, [filters, pagination])

    return (
        <Context.Provider
            value={{
                loading,
                error,
                filters,
                listTenant,
                listParam,
                listTenantParam,
                setPagination,
                pagination,
                total,
                onChangeFilter: _onChangeFilter,
                getListSettingTenant: _fetchListSettingTenant
            }}
        >
            {props.children}
        </Context.Provider>
    )
}

export {
    Context as SettingTenantContext,
    Provider as SettingTenantProvider
} from './SettingTenantContext'
